'use client';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { FOLLOWERS_QUERY_KEY, FOLLOWING_QUERY_KEY } from '@/modules/players/v3/constants/following';
import {
  FRIENDS_QUERY_KEY,
  FRIENDS_TAB_COUNTS_QUERY_KEY,
  RECEIVED_REQUESTS_QUERY_KEY,
} from '@/modules/players/v3/constants/friends';
import { RELATIONSHIP_QUERY_KEY } from '@/modules/players/v3/hooks/use-get-relationship';
import { blockUser } from '@/utils/actions/players/friends/blockUser';

export interface UseBlockUserParams {
  uuid: string;
  blockedUuid: string;
}

export const useBlockUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ uuid, blockedUuid }: UseBlockUserParams) => {
      const res = await blockUser({ uuid, blockedUuid });
      if (res.error) {
        throw new Error(`Failed to block user: ${res.error}`);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [FRIENDS_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [RECEIVED_REQUESTS_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [FRIENDS_TAB_COUNTS_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [RELATIONSHIP_QUERY_KEY] });
      // Blocking severs any existing follow relationship in both directions.
      queryClient.invalidateQueries({ queryKey: [FOLLOWING_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [FOLLOWERS_QUERY_KEY] });
    },
  });
};
